export default "__VITE_ASSET__Cokt9Uct__"